import { useMemo, useState } from 'react';

import { ConfirmationModal } from 'components-antd';

import { useDispatch, useSelector } from 'react-redux';
import { getDynamicFormSelector } from 'store/selectors/requestFormProcess';
import classNames from 'classnames';
import { dynamicManager } from '../DynamicManager';
import { SmartFormIcons } from 'components';
import { FORM_PROCESS_SCREEN } from 'app-constants';

import styles from './styles.module.scss';

import { DownloadButton } from './components/DownloadButton/DownloadButton';
import { useLocation } from 'react-router-dom';
import { Close } from 'components/Icons';
import { CommentBadgeWidget } from '../Containers/DynamicViewer/components/SignatureWidgets/CommentBadgeWidget';

import { PreviewFormHeader } from './components/PreviewFormHeader';
import { SignFormHeader } from './components/SignFormHeader';

export const DynamicHeader = (headerProps) => {
  const { isCanceled, isCompleted, isLoading, screen } = useSelector(getDynamicFormSelector);

  const { state: formState } = useLocation<{ bundleName: string; isWebView?: boolean }>();
  const state = useMemo(() => formState, []);

  const windowState = window.history.state;
  const isWebView = state?.isWebView || windowState?.isWebView;

  const isDeclined = screen === FORM_PROCESS_SCREEN.DeclineSign;
  const isCompleteOrCanceledOrDeclined = isCanceled || isCompleted || isDeclined;

  const [confirmation, setConfirmation] = useState<
    | {
        text: string;
        handleOk: () => void;
      }
    | undefined
  >(undefined);

  return (
    <>
      {confirmation && (
        <ConfirmationModal
          confirmText={confirmation.text}
          onOk={confirmation.handleOk}
          onCancel={() => setConfirmation(undefined)}
          open={!!confirmation}
          confirmLoading={isLoading}
        />
      )}

      {dynamicManager.showPreviewHeader() ? (
        <PreviewFormHeader
          isWebView={isWebView}
          isCanceled={isCanceled}
          isDeclined={isDeclined}
          isCompleted={isCompleted}
          pdfDocAndPageRefs={headerProps.pdfDocAndPageRefs}
          isCompleteOrCanceledOrDeclined={isCompleteOrCanceledOrDeclined}
        />
      ) : (
        <SignFormHeader isWebView={isWebView} {...headerProps} />
      )}
    </>
  );
};
